import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import classnames from 'classnames';
import MusorContent from './MusorContent';
import RendelesekContent from './RendelesekContent';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../JegyertekesitesTooltips';


export default function WithNav(props) {
  return <ErtekesitesBase {...props} />
}

class ErtekesitesBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultRoles:
      [
        {
          rolename: 'JEGYVASARLAS_RENDELES_MUSOR',
          tab: '1',
          spec: false
        },
        {
          rolename: 'JEGYVASARLAS_RENDELES',
          tab: '2',
          spec: false
        }
      ],
      activeTab: '1',
      type: 'MUSOR',
    };
  }

  componentDidMount = () => {
    this.props.globals.setDefaultActiveTab(this.state.defaultRoles, this.toggle);
    // console.log('JEGYELADASBASE PROPS: ', this.props)
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      if (tab === '1') {
        this.setState({ type: 'MUSOR' });
      }
      if (tab === '2') {
        this.setState({ type: 'RENDELESEK' });
      }
      this.setState({ activeTab: tab });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };
    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Helyszíni értékesítés
              {/* <YouTube data={videoData} /> */}
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {this.props.globals.hasRole(['JEGYVASARLAS_RENDELES_MUSOR']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggle('1'); }}
                      >
                        Műsor
                        <CustomTooltip text={getTooltip('musor')} id="musorTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.props.globals.hasRole(['JEGYVASARLAS_RENDELES']) && (
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames({ active: this.state.activeTab === '2' })}
                      onClick={() => { this.toggle('2'); }}
                    >
                      Rendelések
                      <CustomTooltip text={getTooltip('rendelesek')} id="rendelesekTT" />
                    </NavLink>
                  </NavItem>
                  )}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {this.props.globals.hasRole(['JEGYVASARLAS_RENDELES_MUSOR']) && (
                    <TabPane tabId="1">
                      <MusorContent
                        {...this.props}
                        globals={this.props.globals}
                        type={this.state.type}
                      />
                    </TabPane>
                  )}
                  {this.props.globals.hasRole(['JEGYVASARLAS_RENDELES']) && (
                    <TabPane tabId="2">
                      <RendelesekContent
                        {...this.props}
                        globals={this.props.globals}
                        type={this.state.type}
                      />
                    </TabPane>
                  )}
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ErtekesitesBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};


